// extracted by mini-css-extract-plugin
export default {"banner":"FlipTabletBanner--banner--bc4736"};